<template>
  <div>
    <el-dialog
      :visible.sync="showResetDialog"
      :width="modalWidth"
      top="30vh"
      :before-close="handleReset"
      append-to-body
    >
      <main class="flex mb-5 flex-col items-center justify-center">
        <h3 class="text-2xl text-fg-default">Attention</h3>
        <p
          style="word-break: normal"
          class="leading-loose text-xs text-center lg:w-11-12 my-4 lg:text-sm font-light"
        >
          Are you sure you want to discard all changes
        </p>
        <div class="flex items-center gap-x-3 mt-4 w-full px-4">
          <el-button
            class="border-primary text-primary w-full px-4 py-3.5 shadow-xs rounded-lg"
            @click="handleReset"
          >
            Not Sure</el-button
          >
          <el-button
            class="bg-primary text-fg-on-accent px-4 py-3.5 shadow-xs rounded-lg w-full"
            @click="handleSubmit"
          >
            Sure
          </el-button>
        </div>
      </main>
    </el-dialog>
  </div>
</template>

<script>
import breakpoints from '@/utils/breakpoints.js'
import { TEST_URl } from '@/utils/constants.js'

export default {
  props: {
    showResetDialog: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    modalWidth () {
      return breakpoints.lgAndUp ? '30%' : breakpoints.mdAndUp ? '70%' : '90%'
    }
  },
  methods: {
    handleReset () {
      this.$emit('closeRetryDialog')
    },
    handleSubmit () {
      this.$emit('resetBaseUrl')
      localStorage.removeItem(TEST_URl)
      window.location.reload()
    }
  }
}
</script>
<style scoped>
>>> .el-dialog {
  border-radius: 12px;
  padding: 0px 20px 10px 10px;
}
>>> .el-dialog__body {
  padding: 0px 20px;
}
>>> .el-dialog__wrapper {
  overflow: hidden;
  top: 14px;
}
>>> .el-icon-close:before {
  padding: 25px;
  opacity: 0.9;
  color: #c1c4ca;
}
>>> .el-dialog__headerbtn :hover {
  color: #c1c4ca !important ;
}
</style>
